import React from 'react'
import styles from './CardProjeto.module.css'
export default function CardProjeto({ nome, texto, link, imagem }) {
    return (
        <div className={styles.card}>
            <img className={styles.icone} src={imagem} alt={"imagem do projeto: " + nome} />
            <h4 className={styles.nome}>{nome}</h4>
            <p className={styles.texto}>{texto}</p>
            <a className={styles.botao} href={link}>Visitar</a>
        </div>
    )
}
